import _ from "lodash";

class Config {
    static AUTH_API = process.env.REACT_APP_AUTH_API;
    static INFO_API = process.env.REACT_APP_INFO_API;
    static BACKEND_API = process.env.REACT_APP_BACKEND_API;
    static BACKEND_HOME_API = process.env.REACT_APP_BACKEND_HOME_API;
}

export default Config;